import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CartService } from '../../../../services/cart';
import { Router } from '@angular/router';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { UrlSlugifyService } from '../../../../services/url-slugify';
import { Swiper } from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
@Component({
  selector: 'bundle',
  templateUrl: './bundle.component.html',
  styleUrl: './bundle.component.scss'
})
export class BundleComponent {
  @Input() element: any;
  @ViewChild('bundleSwiper', { static: false }) bundleSwiperEl!: ElementRef;
  @Input() isAr: boolean = false;
  @Input() bybrand: boolean = false;
  isMobile: boolean = false;
  showBundleItems: boolean = false;
  bundleSlides: string[] = [];
  swiper?: Swiper;
  product: any;
  isBrowser = typeof window !== 'undefined';
  constructor(
    private cartService: CartService,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private _slugify: UrlSlugifyService
  ) {

  }

  ngOnInit() {

    this.product = this.element;

    this.prepareSlides();

    setTimeout(() => {
      this.initSwiper();
    }, 100);

    this.isMobile = this.deviceService.isMobileDevice();


  }
  prepareSlides(): void {

    if (!this.product) return;

    let images: string[] = [];

    // صورة الباندل الأساسية
    if (this.product.image) {
      images.push(this.fixImage(this.product.image));
    }

    // صور المنتجات اللي جوه الباندل
    if (this.product.items?.length) {
      this.product.items.forEach((item: any) => {
        if (item.stock?.image) {
          images.push(this.fixImage(item.stock.image));
        }
      });
    }

    this.bundleSlides = images;
  }
  private initSwiper(): void {

    if (!this.isBrowser || !this.bundleSwiperEl) return;

    // لو فيه swiper قديم
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.bundleSwiperEl.nativeElement, {
      modules: [Navigation, Pagination, Autoplay],

      navigation: true,
      pagination: { clickable: true },

      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },

      loop: true,
      speed: 1200
    });
  }
  calcDis(newP: any, oldP: any) {

    const off = Math.round(((parseInt(oldP) - parseInt(newP)) / parseInt(oldP)) * 100);
    if (isNaN(off))
      return 0
    else
      return off
  }
  addToCart(product: any, quantiy: any) {
    this.cartService.addToCart(product);
  }
  addBundle(bundle: any) {
    this.cartService.addBundleToCart(bundle);
  }

  fixImage(url: any) {

    return "https://backendproduction.blueboxpet.com/storage/app/public/" + url
  }



  toggleBundleItems() {
    this.showBundleItems = !this.showBundleItems;
  }

  bundletDetails(product: any) {
    this.router.navigate(['/bundle', this._slugify.slugify(product.name_en), product.id]);
  }
  detectNumberofCharacters(name: string) {
    return name.length < 25 && this.isMobile;
  }

}
